import { Environment } from '@classifieds-sell/environment';

export const environment: Environment = {
    production: false,
    apiUrl: `${window.location.origin}/vehicles/api`,
    appBaseHref: '/sell/vehicles/',
    authUrl: 'https://stage.auth.trademe.co.nz',
    frontendUrl: `${window.location.origin}/sell/vehicles`,
    apiBaseUrlForGringotts: 'https://api.stage.trademe.co.nz/"',
    paymentWidgetUrl: 'https://stable.test.ping.trademe.co.nz',
    trademeUrl: 'https://www.stage.trademe.co.nz/',
    tagManagerId: 'GTM-5ZFBB63',
    authClientId: 'motors_sell',
    authScope: 'openid profile email BoatSellApi.Read BoatSellApi.Write'
};
